import { useQuery } from "@tanstack/react-query";
import axios from "../Axios";
import { Urls } from "../Urls";

const fetchRfq = async ({ rfqStatus, skip = 0, limit = 0 }) => {
  const url = `${Urls.auctionBase}tpmp_procurements?procurement_status=${rfqStatus}&skip=${skip}&limit=${limit}`;
  const { data } = await axios.get(url);
  return data;
};

export default function useFetchRfqs(
  rfqStatus = "active",
  skip = 0,
  limit = 10
) {
  const queryKey = ["tpmp_procurements", rfqStatus, skip, limit];

  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey,
    queryFn: () => fetchRfq({ rfqStatus, skip, limit }),
    staleTime: 10000, // data is stale after 1 second
    refetchOnMount: rfqStatus !== "closed",
  });

  return {
    procurements: data?.procurement || [],
    isRfqDataLoading: isLoading,
    IsRfqSilentLoading: isFetching && !isLoading,
    refetch,
    error,
  };
}
